import { useContext } from 'react';

import { ModalServiceContext, RicosContext } from './../../../../ricos-context';

import type { FloatingCustomColorPickerProps } from './floating-custom-color-picker';
import { FloatingCustomColorPicker } from './floating-custom-color-picker';

const CUSTOM_COLOR_PICKER_MODAL_ID = 'custom-color-picker-modal-id';

export const useCustomColorPickerModal = ({
  onClickOutside,
  componentProps,
}: {
  onClickOutside: () => void;
  componentProps: Omit<FloatingCustomColorPickerProps, 'onCancel'>;
}) => {
  const { isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);

  const toggleModal = (ref: HTMLElement | null) => {
    if (isModalOpen()) {
      return closeModal();
    }

    const props: FloatingCustomColorPickerProps = {
      ...componentProps,
      onCancel: closeModal,
    };
    return modalService.openModal({
      id: CUSTOM_COLOR_PICKER_MODAL_ID,
      Component: FloatingCustomColorPicker,
      positioning: { placement: isMobile ? 'bottom' : 'left-start', referenceElement: ref },
      noPadding: true,
      layout: isMobile ? 'fullscreen' : 'popover',
      onClickOutside: e => {
        if (ref && ref.contains(e.target as Node)) {
          closeModal();
          return;
        }
        closeModal();
        onClickOutside();
      },
      componentProps: props,
    });
  };

  const closeModal = () => modalService.closeModal(CUSTOM_COLOR_PICKER_MODAL_ID);

  const isModalOpen = () => modalService.isModalOpen(CUSTOM_COLOR_PICKER_MODAL_ID);

  return { toggleModal, closeModal, isModalOpen };
};
